import { BulkActionStateEnum } from 'owa-bulk-action-store';
import { store as bulkActionStore } from 'owa-bulk-action-store';
export default function isRuleRunning(ruleId, folderId) {
    var runningBulkActionInfo = bulkActionStore.bulkActionInformationMap.get(folderId);
    if (!runningBulkActionInfo) {
        return false;
    }
    var currentState = runningBulkActionInfo.state;
    var ruleBulkActionCustomData = runningBulkActionInfo.customData && JSON.parse(runningBulkActionInfo.customData);
    var scenario = ruleBulkActionCustomData
        ? ruleBulkActionCustomData.Scenario
        : runningBulkActionInfo.class;
    return ((currentState == BulkActionStateEnum.Uninitialized ||
        currentState == BulkActionStateEnum.Running) &&
        scenario == 'RunRuleNow' &&
        ruleBulkActionCustomData.ruleId == ruleId);
}
//# sourceMappingURL=isRuleRunning.js.map